import { v4 as uuidv4 } from 'uuid';

// eslint-disable-next-line import/prefer-default-export
export const createNotification = (status, message) => ({
  id: uuidv4(),
  status,
  message,
});
